import { create } from 'zustand';

type CrawlerUnseenState = {
  triggerUnseenByApplicationId: Record<string, boolean>;
  historyUnseenByApplicationId: Record<string, boolean>;
  markTriggerUnseen: (applicationId: string) => void;
  markHistoryUnseen: (applicationId: string) => void;
  clearTriggerUnseen: (applicationId: string) => void;
  clearHistoryUnseen: (applicationId: string) => void;
  hasTriggerUnseen: (applicationId: string | undefined) => boolean;
  hasHistoryUnseen: (applicationId: string | undefined) => boolean;
};

export const useCrawlerUnseenStore = create<CrawlerUnseenState>((set, get) => ({
  triggerUnseenByApplicationId: {},
  historyUnseenByApplicationId: {},
  markTriggerUnseen: (applicationId) => {
    if (!applicationId) {
      return;
    }

    set((state) => {
      if (state.triggerUnseenByApplicationId[applicationId]) {
        return state;
      }

      return {
        triggerUnseenByApplicationId: {
          ...state.triggerUnseenByApplicationId,
          [applicationId]: true,
        },
      };
    });
  },
  markHistoryUnseen: (applicationId) => {
    if (!applicationId) {
      return;
    }

    set((state) => {
      if (state.historyUnseenByApplicationId[applicationId]) {
        return state;
      }

      return {
        historyUnseenByApplicationId: {
          ...state.historyUnseenByApplicationId,
          [applicationId]: true,
        },
      };
    });
  },
  clearTriggerUnseen: (applicationId) => {
    if (!applicationId) {
      return;
    }

    set((state) => {
      if (!state.triggerUnseenByApplicationId[applicationId]) {
        return state;
      }

      const next = { ...state.triggerUnseenByApplicationId };

      delete next[applicationId];

      return { triggerUnseenByApplicationId: next };
    });
  },
  clearHistoryUnseen: (applicationId) => {
    if (!applicationId) {
      return;
    }

    set((state) => {
      if (!state.historyUnseenByApplicationId[applicationId]) {
        return state;
      }

      const next = { ...state.historyUnseenByApplicationId };

      delete next[applicationId];

      return { historyUnseenByApplicationId: next };
    });
  },
  hasTriggerUnseen: (applicationId) => {
    if (!applicationId) {
      return false;
    }

    return !!get().triggerUnseenByApplicationId[applicationId];
  },
  hasHistoryUnseen: (applicationId) => {
    if (!applicationId) {
      return false;
    }

    return !!get().historyUnseenByApplicationId[applicationId];
  },
}));
